export interface IAoeNewUserWizard {
  businessName: string;
  bankDetails: IBankDetails;
  frenchContribution: IFrenchContribution;
  contractAgreement: IContractAgreement;
  vatInformation: IVatInformation;
}

export enum WizardSteps {
  ContractAgreement = 1,
  BusinessInfo = 2,
  FrenchContribution = 3,
  VatInformation = 4,
  BankDetails = 5,
}

export interface IWizardStepProps {
  formData: IAoeNewUserWizard;
  onUpdate: (data: Partial<IAoeNewUserWizard>) => void;
  isValid: boolean;
}

export interface IBankDetails {
  bankAccountType: string;
  bankName: string;
  bic: string;
  iban: string;
  directDeposit: boolean;
  opa: boolean;
  cddCodeIdBankingType: string;
}

export interface IFrenchContribution {
  beeNumber: number;
  birthCity: string;
  birthCountry: string;
  frenchCitizen: boolean;
  authorizedToWork: boolean;
  employeeStatus: string;
  ssn: string;
  siret: string;
  taxExemptionCode: string;
  codeIdExternalTaxId: string;
}

export interface IVatInformation {
  vatType: string;
  beeNumber: string;
  taxExemptCode: string;
}

import type { IContractAgreement } from './ContractAgreementTypes';
